module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Adress-book2-ee0bbefe27c5befca64ea6111f6ffbb4.svg";